module.exports = __webpack_public_path__ + "static/img/76107F_4_C_20230802_LC.d341e3a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/76107F_4_C_20230802_LC.png
// module id = rdtU
// module chunks = 0